package com.macrofocus.eflux.network.logical

import com.macrofocus.eflux.network.CombinedBranches
import com.macrofocus.eflux.network.CombinedBuses
import com.macrofocus.eflux.network.physical.Branch
import com.macrofocus.eflux.network.physical.Bus
import org.molap.network.AbstractNetwork
import org.molap.network.Network

class LogicalNetwork(physicalNetwork: Network<Bus, Branch>) : AbstractNetwork<CombinedBuses, CombinedBranches>() {
    val logicalNodes = physicalNetwork.nodes
        .groupBy { logicalBusIdOf(it.id) }
        .mapValues { CombinedBuses(it.key, it.value) }

    val logicalLinks = physicalNetwork.links
        .filter { logicalBusIdOf(it.from.id) != logicalBusIdOf(it.to.id) }
        .groupBy { logicalBranchIdOf(logicalBusIdOf(it.from.id), logicalBusIdOf(it.to.id), it.record.ckt) }
        .mapValues {
            if(it.value.size == 0) {
                println("No record found for " + it.key)
            } else if(it.value.size > 1) {
                println("Multiple (" + it.value.size + ") branches detected for " + it.key)
            }
            CombinedBranches(it.key.from,it.key.to, it.value.first())
        }
    //            .groupBy { UndirectedLink(logicalNodes[logicalBusIdOf(it.from.id)], logicalNodes[logicalBusIdOf(it.to.id)]) }
//            .mapValues { CombinedBranches(it.key.from!!,it.key.to!!, it.value) }

    init {
        logicalNodes.forEach { addNode(it.value) }
        logicalLinks.forEach { addUndirectedEdge(logicalNodes[it.key.from]!!, logicalNodes[it.key.to]!!, it.value) }
    }

    override fun getFrom(link: CombinedBranches): CombinedBuses = logicalNodes[link.from]!!

    override fun getTo(link: CombinedBranches): CombinedBuses = logicalNodes[link.to]!!
}
